import { render, staticRenderFns } from "./PaginationTable.vue?vue&type=template&id=63361fc9&scoped=true"
import script from "./PaginationTable.vue?vue&type=script&lang=js"
export * from "./PaginationTable.vue?vue&type=script&lang=js"
import style0 from "./PaginationTable.vue?vue&type=style&index=0&id=63361fc9&prod&lang=css"
import style1 from "./PaginationTable.vue?vue&type=style&index=1&id=63361fc9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63361fc9",
  null
  
)

export default component.exports